import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ADD_DAYCARE_MEAL_HABIT } from '@/modules/API/meal/daycareSettingsHandler.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'

interface AddMealHabitDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
}

const AddMealHabitDialog: FunctionComponent<AddMealHabitDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId
}: AddMealHabitDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [habit, setHabit] = useState<string>('')

    const [addMealHabit] = useMutation(ADD_DAYCARE_MEAL_HABIT, {
        variables: {
            daycareId,
            habit
        },
        onCompleted: () => {
            refetch()
            handleClose()
            setHabit('')
            showNotificationSuccess(t('mealHabitAdded'))
        },
        onError: () => {
            handleClose()
            setHabit('')
            showNotificationError(t('mealHabitAddedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('addMealHabit')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={habit}
                    setValue={setHabit}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 1, max: 256 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='add'
                        disabled={habit.length < 1 || habit.length > 256}
                        onClick={() => addMealHabit()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default AddMealHabitDialog
